import React, { useState } from 'react';
import MDEditor, { commands } from '@uiw/react-md-editor';
import rehypeSanitize from 'rehype-sanitize';

import { FormControl, Box, FormHelperText, Typography } from '@mui/material';

export default function DealExecSummaryField({
  value,
  error,
  setValue,
  setError,
}) {
  const MAX_LENGTH = 2000;
  const [charCount, setCharCount] = useState(value ? value.length : 0);
  const handleChange = (text) => {
    if (text.length <= MAX_LENGTH) {
      setValue(text);
      setCharCount(text.length);
    }
  };

  return (
    <Box>
      <FormControl fullWidth aria-describedby='exec-summary-helper-text'>
        <Typography variant='caption' color={'rgba(0, 0, 0, 0.6)'}>
          Executive Summary
        </Typography>

        <MDEditor
          commands={[
            commands.title3,
            commands.title4,
            commands.bold,
            commands.italic,
            commands.strikethrough,
            commands.link,
            commands.unorderedListCommand,
            commands.orderedListCommand,
            commands.checkedListCommand,
          ]}
          minHeight={250}
          height={'100%'}
          preview='edit'
          data-color-mode='light'
          value={value}
          onChange={handleChange}
          previewOptions={{
            rehypePlugins: [[rehypeSanitize]],
          }}
        />

        <FormHelperText id='exec-summary-helper-text'>
          Enter a summary of the deal and its key attributes. What makes it
          unique? What are the major selling points? ({charCount}/{MAX_LENGTH})
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
